import React, {useState,useEffect,useContext} from 'react';
import {useHistory} from 'react-router-dom';
import ModalMesa from './ModalMesa';
import ModalTicket from './ModalTicket'
import UIfx from 'uifx';
import BeepSound from '../../alerts/new.mp3';
import io from 'socket.io-client';
import AuthContext from '../../context/authContext/authContext';
import { makeStyles } from '@material-ui/core/styles';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import SentimentVerySatisfiedIcon from '@material-ui/icons/SentimentVerySatisfied';
import AdminContext from '../../context/adminContext/adminContext';
import DeleteIcon from '@material-ui/icons/Delete';
import ClearIcon from '@material-ui/icons/Clear';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import FavoriteIcon from '@material-ui/icons/Favorite';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import {
        TableContainer,
        Table,
        TableHead,
        TableBody,
        TableRow,
        TableCell,
        IconButton,
        Collapse,
        Box,
        Typography,
        Paper,
        Card,
        CardContent,
        Button,
        CircularProgress
                } from '@material-ui/core';

                
                
                
                
                
//ESTILO VISTA                
const styles = makeStyles((theme)=> ({
    root: {
        maxWidth: '1024px',
        display: 'block'
    },
    heading: {
        fontSize: theme.typography.pxToRem(22),
        fontWeight: theme.typography.fontWeightBold,
    },
    table : {
        marginBottom : '2rem',
        minWidth: 340,
        width : '100%'
    },
    tableCell: {
      paddingRight: 4,
      paddingLeft: 5,
     
    },

  
    
                  
                 
}));   
//ESTILOS TABLA
const useRowStyles = makeStyles((theme) =>({
  root: {
    textTransform : 'capitalize',
    
    '& > *': {
      borderBottom: 'unset',
      
    },
  },
  actions : {
    width:'100 %',
    display:'flex',
    justifyContent : 'space-evenly'
  },
  list : {
    display : 'flex',
    marginBottom : '.1rem',
    alignItems: 'center',
    '& h6 ' : {
        marginLeft : theme.spacing(1),
        textTransform: 'capitalize'
    },
  },
  details : {
    textTransform : 'capitalize'
  },
  deleteBebida: {
    display : 'flex',
    alignItems : 'center'
  },
  puntito : {
    backgroundColor : "blue",
    width: '10px',
    height : '10px',
    borderRadius : '50%'
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
 

  
}));      
                
//VISTA DE LOS PEDIDOS
function Pedido(props) {
  const { pedido, setisloading, isloading,setopenTicket,setmesa } = props;
  const mesera = pedido.mesera;
  const [open, setOpen] = React.useState(false);
  const [cierre, setcierre] = useState(false);
  const [cerrar, setcerrar] = useState(null);
  const classes = useRowStyles(mesera);
  const history = useHistory();
  //CONTEXT
  const adminContext = useContext(AdminContext);
  const {
      deletePedido,
      deleteMenu,
      delBebida,
      delIngrediente,
  } = adminContext;
  const authContext = useContext(AuthContext);
  const {cliente} = authContext;
  //FUNCIONES    

    //CERRAR MESA
    const abrirTicket = pedido => {
      setmesa(pedido)
      setopenTicket(true)

    }
    //ELIMINAR PEDIDO
    const delPedido = async pedido=> {
        setcierre(true)
        setcerrar(pedido)
      }
    const cancelanding = async cerrar => {
      setcierre(false)
      setisloading(true)
      await deletePedido(cerrar)
      setcerrar(pedido)
      setisloading(false)
    }
    const handleClose = () => {
      setcierre(false)
      setcerrar(null)
    }   
    //AGREGAR MENU
    const addMenu = (pedido) => {
       history.push({
           pathname : '/admin/add_salon',
           state : {pedido : pedido}
       })
    }
    //ELIMINAR BEBIDA
    const deleteBebida = async (pedido , idMenu , idBebida) => {
      setisloading(true)
      await delBebida(pedido, idMenu,idBebida)
      setisloading(false)
    }
    //ELIMINAR INGREDIENTE
    const deleteIngrediente = async (pedido, idMenu, idIngrediente) => {
      setisloading(true)
      await delIngrediente(pedido, idMenu,idIngrediente)
      setisloading(false)
    }
  return (
    <React.Fragment>
       <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={cierre}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={cierre}>
          <div className={classes.paper}>
            <h2 id="transition-modal-title">Esta seguro que desea cancelar el pedido de {cerrar ? cerrar.mesa : null} ?</h2>
            <div className={classes.actions}>
            <Button variant="contained" onClick={handleClose}>Cancelar</Button>
            <Button disabled={isloading} variant="contained" color="secondary" onClick={() => cancelanding(cerrar)}>Aceptar</Button>
            </div>
          </div>
        </Fade>
      </Modal>
      <TableRow className={classes.root}>
        <TableCell >
        {pedido.mesera === "agus mesera" || 
        pedido.mesera === "mesera" ||
        pedido.mesera === "mesera2" ? <SentimentVerySatisfiedIcon fontSize="large" color={pedido.mesera === "agus mesera" ? "error" :
            pedido.mesera === "mesera" ? 'primary' :
            pedido.mesera === "mesera2" ? 'secondary' : "inherit"}/> 
            : <FavoriteIcon fontSize="large" color={pedido.mesera === "Federico" ? 'primary' : 'error' }/>}
          <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon fontSize="large" color="secondary" /> : <KeyboardArrowDownIcon color="secondary" fontSize="large"/>}
          </IconButton>
        </TableCell>
      
        <TableCell component="th" scope="row" >
  
          {pedido.cliente_manual ? pedido.cliente_manual.nombre : null}
          {pedido.cliente_registrado ? pedido.cliente_registrado.nombre : null}
          {pedido.mesa ? pedido.mesa : null}
        </TableCell>
       
        <TableCell  align="right">{pedido.referencia}</TableCell>
        <TableCell align="right" >{pedido.enCamino ? "Despachado" : "En elaboracion"}</TableCell>
        <TableCell align="right" >{pedido.fecha}</TableCell>
        <TableCell align="center" className={classes.actions}>
                     <IconButton  onClick={() => addMenu(pedido)}><AddShoppingCartIcon color='primary'/></IconButton> 
                    <Button disabled={isloading} variant="contained" color='secondary' size="small" onClick={()=>delPedido(pedido)}>Cancelar Pedido</Button>
                    <Button variant="contained" color="primary" size="small" disabled={pedido.enCamino === false || cliente.nombre === "mesera" || cliente.nombre === "mesera2" } onClick={(e)=>abrirTicket(pedido)}>Cerrar Mesa</Button> 
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell  style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
            <Card >
                <CardContent>
                    
                    {pedido.tipo === "domicilio" ? 
                        <div className={classes.list}>
                        <Typography   >Domicilio:</Typography>
                        <Typography variant="subtitle2">{pedido.domicilio}</Typography>
                        </div> : null}
                    {pedido.referencia ? 
                    <div className={classes.list}>
                        <Typography >Referencia : </Typography>
                        <Typography variant="subtitle2">{pedido.referencia}</Typography>
                    </div> : null}
                </CardContent>
            </Card>
              <Typography variant="h6" gutterBottom component="div">
                
              </Typography>
              <Table size="small" aria-label="purchases" >
                <TableHead>
                  <TableRow>
                    <TableCell colSpan={6}>DETALLE</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody >
                  <TableRow>
                    <TableCell colSpan={1}><Typography variant="subtitle2">MENU</Typography></TableCell>
                    <TableCell colSpan={2}><Typography variant="subtitle2">INGREDIENTES</Typography></TableCell>
                    <TableCell colSpan={2}><Typography variant="subtitle2">BEBIDAS</Typography></TableCell>
                    <TableCell colSpan={1} align="right"><Typography variant="subtitle2">SUBTOTAL</Typography></TableCell>
                  </TableRow>
                  {pedido.menu.despachado ? null :
                    pedido.menu.map(men =>{
                      
                    return <TableRow  className={classes.details} key={men._id}>
                      <TableCell colSpan={1}><Typography>{men.platos ? men.platos.nombre : "--"}</Typography></TableCell>
                      <TableCell colSpan={2}>
                       {men.ingredientes.map(ingrediente => {
                       return <div className={classes.deleteBebida}>
                              <Typography key={ingrediente._id}>{ingrediente.nombre}</Typography>
                       <IconButton  onClick={()=> deleteIngrediente(pedido, men._id, ingrediente._id)} aria-label="delete"> 
                                             <DeleteIcon color='error'/>
                                       </IconButton> 
                       </div>
                      })}
                      </TableCell>
                      <TableCell colSpan={2}>
                        {men.bebidas.length === 0 ? <Typography>--</Typography> : null}
                        {men.bebidas.map(bebida => {
                          return <div className={classes.deleteBebida}>
                                  <Typography key={Math.random()}>{bebida.nombre}</Typography>
                                  <IconButton  onClick={()=> deleteBebida(pedido, men._id, bebida._id)} aria-label="delete"> 
                                                        <DeleteIcon color='error'/>
                                                  </IconButton> 
                                  </div>
                        })}
                      </TableCell>
                      <TableCell colSpan={1} align="right">{`$ ${men.subtotal}`}
                     
                      </TableCell>
                      <TableCell>
                      {pedido.menu.length !== 0 ? <IconButton  onClick={()=> deleteMenu(pedido, men._id)} aria-label="delete"> 
                                                        <ClearIcon color='error'/>
                                                  </IconButton>
                                                : null}
                      </TableCell>
                    
                    </TableRow>
                  })}
              
             
                <TableRow>
                    <TableCell rowSpan={5} />
                    <TableCell colSpan={2} align="right"><Typography variant="subtitle2">TOTAL</Typography></TableCell>
                    <TableCell colSpan={3} align="right"><Typography variant="h6">{`$ ${pedido.precio_total}`}</Typography> </TableCell>
                </TableRow>
                
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}                
                
const PedidoCerrado = props => {
  const { pedido, setopenModal, setmesa } = props;
  const authContext = useContext(AuthContext);
  const {cliente} = authContext;
  const classes = useRowStyles();
  const adminContext = useContext(AdminContext);
  const {
    anule
  } = adminContext;
 
     //CERRAR MESA
     const confirmarCerra = async pedido => {
      setopenModal(true);
      setmesa(pedido)
    }
    // ANULAR CIERRE
    const anularCierre = async pedido => {
      await anule(pedido);
    }
  return (
    <>
    <TableRow className={classes.root}>
       <TableCell align="center" colSpan={2} className={classes.tableCell}>
       {pedido.mesera === "agus mesera" || 
        pedido.mesera === "mesera" ||
        pedido.mesera === "mesera2" ? <SentimentVerySatisfiedIcon fontSize="large" color={pedido.mesera === "agus mesera" ? "error" :
            pedido.mesera === "mesera" ? 'primary' :
            pedido.mesera === "mesera2" ? 'secondary' : "inherit"}/> 
            : <FavoriteIcon fontSize="large" color={pedido.mesera === "Federico" ? 'primary' : 'error' }/>}
         <Typography variant="subtitle2">
         {pedido.mesa}
         </Typography></TableCell>
       <TableCell align="right" colSpan={1}><Typography variant="subtitle2">{pedido.referencia}</Typography></TableCell>
       <TableCell align="right" colSpan={1}><Typography variant="subtitle2">{pedido.fecha}</Typography></TableCell>
       <TableCell align="right" colSpan={1}><Typography variant="subtitle2">${pedido.precio_total}</Typography></TableCell>
       <TableCell align="center" >
       
        <Button style={{
          marginRight : '5px'
        }} variant="contained" color="primary" size="small" disabled={pedido.enCamino === false || cliente.nombre === "mesera" || cliente.nombre === "mesera2" } onClick={()=> confirmarCerra(pedido)}>Cobrar</Button>
        <Button variant="contained" color="secondary" size="small" disabled={pedido.enCamino === false || cliente.nombre === "mesera" || cliente.nombre === "mesera2" } onClick={()=> anularCierre(pedido)}>Anular cierre</Button>
        
       
       </TableCell>
    </TableRow>
    </>
  )
}

const VerSalon = (props) => {
    const {pedidos , setisloading , setMensaje} = props ;
    //ESTILOS
    const classes = styles();
    //STATE LOCALES
    const [openTicket, setopenTicket] = useState(false);
    const [pedidosSalon, setpedidosSalon] = useState(null);
    const [pedidosCerrados, setpedidosCerrados] = useState(null);
    const [openModal, setopenModal] = useState(false);
    const [mesa, setmesa] = useState();
    
    //EFFECT
    const socket = io(process.env.REACT_APP_BACKEND_URL);
    const beep = new UIfx(BeepSound , {
      volume: 1, // number between 0.0 ~ 1.0
      throttleMs: 100
    });
    useEffect(() => {
     socket.on('despacho' , mensaje => {
       
        beep.play()
        window.navigator.vibrate(1000)
        setMensaje(mensaje)
        setTimeout(() => {
          alert(`${mensaje.pedido} ${mensaje.creador}`)
        }, 2000);
    

        
      })
      
     
      return ( ) => { socket.off()}
       // eslint-disable-next-line
    }, []);
    useEffect(() => {
    
      
      socket.on('eliminarIngrediente' , mensaje => {
       
        beep.play()
        window.navigator.vibrate(1000)
        setMensaje(mensaje)
        setTimeout(() => {
          alert(`${mensaje.pedido} ${mensaje.creador}`)
        }, 2000);
    

        
      })
      
     
      return ( ) => { socket.off()}
       // eslint-disable-next-line
    }, []);
    useEffect(() => {
        let newArray = [];
        let otroArray = []
        if(pedidos){
          pedidos.forEach(pedido  => {
            if(pedido.tipo === "Salon"){
                if(pedido.cerrado ){
                  otroArray.push(pedido)
                }else{
                  newArray.push(pedido);
                }
            }
          });
        }
        setpedidosSalon(newArray)
        setpedidosCerrados(otroArray)
         // eslint-disable-next-line
    }, [pedidos]);
    return ( 
    <>
       <ModalTicket
       openTicket={openTicket}
       setisloading={setisloading}
       mesa = {mesa}
       setopenTicket = {setopenTicket}
      
      
       />
       <ModalMesa
        openModal={openModal}
        setisloading={setisloading}
        mesa = {mesa}
        setopenModal = {setopenModal}

       /> 

      <Typography variant = "h4" gutterBottom={true} align="center">Mesas</Typography>
      <TableContainer component={Paper} className={classes.table}>
      <Table aria-label="collapsible table" >
        <TableHead>
          <TableRow>
          <TableCell />
            <TableCell>Mesa </TableCell>  
            <TableCell align="right">Referencia</TableCell>
            <TableCell align="right">Estado</TableCell>
            <TableCell align="right">Hora de Pedido</TableCell>
            <TableCell align="center">Acciones</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
        {pedidosSalon !== null ? 
            pedidosSalon.length > 0 ? pedidosSalon.map(pedido =>{
              return <Pedido key={pedido._id} pedido={pedido} setisloading={setisloading} setopenModal={setopenModal} setopenTicket = {setopenTicket} setmesa={setmesa}/>
             }) : <TableRow key={Math.random()}>
                    <TableCell colSpan={6}>
                      <Typography align="center" variant="h6">No hay pedidos en el Salon</Typography>
                    </TableCell>
                  </TableRow> 
            :<TableRow key={2}>
              <TableCell colSpan={6}>
                <Typography align='center' component="div">   <CircularProgress color="secondary" /></Typography>
              </TableCell>
            </TableRow>  }
        </TableBody>
      </Table>
    </TableContainer>
    <Typography variant = "h4" gutterBottom={true} align="left">Pendientes de cobro</Typography>
      <TableContainer component={Paper} className={classes.table}>
      <Table aria-label="collapsible table" >
        <TableHead>
          <TableRow>
          <TableCell />
            <TableCell>Mesa </TableCell>  
            <TableCell align="right">Referencia</TableCell>
            <TableCell align="right">Hora de Pedido</TableCell>
            <TableCell align="right">Total</TableCell>
            <TableCell align="center">Acciones</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          
              {pedidosCerrados !== null ? 
                pedidosCerrados.length > 0 ? pedidosCerrados.map(pedido =>{
              return <PedidoCerrado key={pedido._id} pedido={pedido} setisloading={setisloading}  setmesa={setmesa} setopenModal={setopenModal}/>
             }) : <TableRow key={1}>
                    <TableCell colSpan={6}>
                      <Typography align="center" variant="h6">No hay mesas cerradas pendientes de cobro</Typography>
                    </TableCell>
                  </TableRow> 
            :<TableRow>
              <TableCell colSpan={6}>
                <Typography align='center' component="div">   <CircularProgress color="secondary" /></Typography>
              </TableCell>
            </TableRow>  }
        </TableBody>
      </Table>
    </TableContainer>
    </>
     );
}
 
export default VerSalon;